import QuizSharpIcon from "@mui/icons-material/QuizSharp";
import AssignmentSharpIcon from "@mui/icons-material/AssignmentSharp";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import EventIcon from "@mui/icons-material/Event";
export const getTypeIcon = (type) => {
  switch (type) {
    case "ASSIGNMENT":
      return <AssignmentSharpIcon color="primary" />;
    case "EXAM":
      return <NoteAltIcon color="error" />;
    case "QUIZ":
      return <QuizSharpIcon color="secondary" />;

    case "EVENT":
      return <EventIcon color="success" />;
  }
};
